export default __webpack_public_path__ + "static/media/lieferheld_s2.df8b99c4.png";